export default __webpack_public_path__ + "static/media/mov.e2febe2c.svg";